// src/data/words.js
export const wordsByMonth = {
  January: [
    "over",
    "did",
    "down",
    "only",
    "way",
    "find",
    "may",
    "water",
    "long",
    "little",
    "very",
    "after",
  ],
  February: [
    "called",
    "just",
    "most",
    "know",
    "red",
    "blue",
    "yellow",
    "day",
    "away",
    "look",
    "jump",
    "play",
  ],
  March: [
    "called",
    "just",
    "most",
    "know",
    "red",
    "blue",
    "yellow",
    "day",
    "away",
    "look",
    "jump",
    "play",
  ],
  April: [
    "an",
    "at",
    "be",
    "we",
    "to",
    "the",
    "is",
    "it",
    "in",
    "are",
    "and",
    "you",
  ],
  May: [
    "for",
    "by",
    "as",
    "of",
    "he",
    "she",
    "was",
    "with",
    "but",
    "can",
    "I",
    "a",
  ],
  June: [
    "how",
    "had",
    "there",
    "their",
    "they",
    "were",
    "have",
    "from",
    "each",
    "word",
    "said",
    "when",
  ],
  July: [
    "his",
    "her",
    "do",
    "if",
    "all",
    "not",
    "or",
    "your",
    "this",
    "that",
    "on",
    "use",
  ],
  August: [
    "which",
    "what",
    "where",
    "will",
    "about",
    "up",
    "one",
    "out",
    "them",
    "then",
    "many",
    "some",
  ],
  September: [
    "so",
    "these",
    "would",
    "other",
    "into",
    "has",
    "more",
    "two",
    "like",
    "him",
    "see",
    "time",
  ],
  October: [
    "could",
    "no",
    "make",
    "than",
    "first",
    "been",
    "its",
    "who",
    "now",
    "people",
    "my",
    "made",
  ],
  November: [
    "could",
    "no",
    "make",
    "than",
    "first",
    "been",
    "its",
    "who",
    "now",
    "people",
    "my",
    "made",
  ],
  December: [
    "over",
    "did",
    "down",
    "only",
    "way",
    "find",
    "may",
    "water",
    "long",
    "little",
    "very",
    "after",
  ],
};
